"use client";
import * as React from "react";
const SvgBuildRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M8.36 1.43A4.9 4.9 0 0 0 2.75.49l2.74 2.73a.75.75 0 0 1 0 1.06l-1.2 1.2a.74.74 0 0 1-1.07 0L.5 2.74a4.9 4.9 0 0 0 .94 5.58 4.9 4.9 0 0 0 5.2 1.11l6 5.98a1.97 1.97 0 0 0 2.79 0 1.96 1.96 0 0 0 0-2.79L9.45 6.68a4.9 4.9 0 0 0-1.1-5.25" }));
export {
  SvgBuildRound as default
};
